import React from 'react';
import PropTypes from 'prop-types';

import { Field, FieldArray } from 'redux-form';
import { FormElems } from '..';

const renderSurchargeBankSlab = ({ fields, isViewMode }) => {
    return (
        <>
            {fields.map((item, index) => (
                <ul className="slabCard-container border-bottom">
                    <FieldArray name={`${item}.bankSlabs`} component={renderBankSlabItems} isViewMode={isViewMode} />
                </ul>
            ))}
        </>
    );
};

const renderBankSlabItems = ({ fields, isViewMode }) => {
    // const section = sectionData.length > 0 ? sectionData : [];
    // eslint-disable-next-line react/prop-types
    const section = fields.getAll();
    // if lower slab <=2000 and higher lab is null
    const noSlab = section.find(item => {
        return item.lowerSlab !== null && item.lowerSlab < 2000 && !item.higherSlab;
    });

    const tiles = (item, index) => {
        return (
            <li className={!noSlab ? 'cardTile' : ''}>
                <div className="slab-title">
                    <div className="title">ODS FEE</div>
                </div>
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">Percent</p>
                        <Field
                            name={`${item}.feePercent`}
                            id={`${item}-feePercent`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="%"
                            postfixContent="%"
                            disabled={isViewMode}
                            borderRadius="5px"
                            maxDecimals={4}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Flat</p>
                        <Field
                            name={`${item}.feeFlat`}
                            id={`${item}-feeFlat`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="INR"
                            disabled={isViewMode}
                            maxDecimals={2}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Criteria</p>
                        <Field
                            name={`${item}.feeCriteria`}
                            id={`${item}-feeCriteria`}
                            data={[
                                {
                                    label: 'Minimum',
                                    value: 'MINIMUM',
                                },
                                {
                                    label: 'Maximum',
                                    value: 'MAXIMUM',
                                },
                                {
                                    label: 'Both',
                                    value: 'BOTH',
                                },
                            ]}
                            labelField="label"
                            valueField="value"
                            component={FormElems.Select}
                            label="Criteria"
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Tax</p>
                        <Field
                            name={`${item}.tax`}
                            id={`${item}-tax`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="%"
                            postfixContent="%"
                            disabled={isViewMode}
                            borderRadius="5px"
                            maxDecimals={2}
                        />
                    </div>
                </div>
            </li>
        );
    };

    const renderSlabs = () => {
        // eslint-disable-next-line array-callback-return
        const leftSlab = fields.map((item, index) => {
            if (section[index].higherSlab && section[index].higherSlab <= 2000) {
                return tiles(item, index);
            }
        });

        return <ul className="leftSlab-container slabCard-container slab">{leftSlab}</ul>;
    };

    if (noSlab) {
        return fields.map((item, index) => {
            return tiles(item, index);
        });
    }
    return <div style={{ display: 'flex' }}>{renderSlabs()}</div>;
};

renderSurchargeBankSlab.propTypes = {
    fields: PropTypes.object.isRequired,
    isViewMode: PropTypes.bool,
};
renderBankSlabItems.propTypes = {
    fields: PropTypes.object.isRequired,
    isViewMode: PropTypes.bool,
};

export default renderSurchargeBankSlab;
